import { render, staticRenderFns } from "./DropboxDisk.vue?vue&type=template&id=fbe42512&"
import script from "./DropboxDisk.vue?vue&type=script&lang=js&"
export * from "./DropboxDisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbe42512')) {
      api.createRecord('fbe42512', component.options)
    } else {
      api.reload('fbe42512', component.options)
    }
    module.hot.accept("./DropboxDisk.vue?vue&type=template&id=fbe42512&", function () {
      api.rerender('fbe42512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/disks/DropboxDisk.vue"
export default component.exports